import {BaseFormModel} from '../base-form-model';

export class CashAuditCurrentSummary extends BaseFormModel<CashAuditCurrentSummary> {
    id: number;
    trackCashTips: boolean;
    amount: number;
    tips: number;
    total: number;
}
